// 라이트/다크 토글 (시스템 + localStorage)
import { useEffect, useState } from 'react'

const STORAGE_KEY = 'mes_theme'
type Theme = 'light' | 'dark' | 'system'

function applyTheme(t: Theme) {
  const html = document.documentElement
  if (t === 'system') html.removeAttribute('data-theme')
  else html.setAttribute('data-theme', t)
}

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    if (typeof window === 'undefined') return 'system'
    return (localStorage.getItem(STORAGE_KEY) as Theme) ?? 'system'
  })

  useEffect(() => {
    applyTheme(theme)
    if (theme === 'system') localStorage.removeItem(STORAGE_KEY)
    else localStorage.setItem(STORAGE_KEY, theme)
  }, [theme])

  const cycle = () =>
    setTheme((t) => (t === 'light' ? 'dark' : t === 'dark' ? 'system' : 'light'))
  return { theme, setTheme, cycle }
}
